export default new class Incidence {
    id = null
    title = ""
    shortTitle = ""
    severity = 1
    categoryId = 1
    categoryTitle = ""
    disabledAt = null
    notification  = false
}()